import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage'; 
import { getStorage } from "firebase/storage";
import { getFirestore } from 'firebase/firestore';

import { resolve, ANALYTICS_ENABLED } from './firebase-projects';

// live: prmassist-marketplace.  sandbox: prm-sandbox-env.  sgs: prmassist-sgs.
const firebaseConfig = resolve('marketplace');

try {
    firebase.initializeApp(firebaseConfig, "marketplace");
    //firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE);
  } catch (err) {
    if (!/already exists/.test(err.message)) {
      console.error('Firebase initialization error', err.stack);
    }
  }

const fire = firebase;
export default fire;

// Initialize Firebase
const app = initializeApp(firebaseConfig, "marketplace");
export {app}
export const storage = getStorage(app);
const firestore = getFirestore(app);
export {firestore}

if (ANALYTICS_ENABLED) {
  try {
    getAnalytics(app);
  } catch (e) {
    if (!/already exists/.test(e.message)) {
      console.warn('Firebase Analytics unavailable (marketplace):', e.message);
    }
  }
}
